module.exports = __webpack_public_path__ + "static/media/web.648504a9.png";